import type { AccessMatrixRow, AuditLogEntry } from '../model/adminSchema';

/**
 * GET /api/admin/access-matrix — матрица прав (Epic-1, US-1.2).
 * Ячейки: 'full' = RW, 'view' = RO, 'none' = нет доступа.
 * Скоупы «по подразделению / участку / только свои» — на уровне данных (фильтрация), не в ячейке.
 */
export const accessMatrix: AccessMatrixRow[] = [
  {
    module: 'Дашборд KPI и контрольных показателей',
    admin: 'full',
    ot_specialist: 'full',
    department_head: 'view',
    master: 'view',
    viewer: 'view',
    employee: 'view',
  },
  {
    module: 'Сотрудники и карточка сотрудника',
    admin: 'full',
    ot_specialist: 'full',
    department_head: 'view',
    master: 'view',
    viewer: 'view',
    employee: 'view',
  },
  {
    module: 'Медосмотры',
    admin: 'full',
    ot_specialist: 'full',
    department_head: 'view',
    master: 'view',
    viewer: 'view',
    employee: 'view',
  },
  {
    module: 'Обучение и инструктажи',
    admin: 'full',
    ot_specialist: 'full',
    department_head: 'view',
    master: 'view',
    viewer: 'view',
    employee: 'view',
  },
  {
    module: 'СОУТ и ОПР',
    admin: 'full',
    ot_specialist: 'full',
    department_head: 'view',
    master: 'view',
    viewer: 'view',
    employee: 'view',
  },
  {
    module: 'Нормы СИЗ',
    admin: 'full',
    ot_specialist: 'full',
    department_head: 'view',
    master: 'view',
    viewer: 'view',
    employee: 'view',
  },
  {
    module: 'Администрирование и настройки',
    admin: 'full',
    ot_specialist: 'none',
    department_head: 'none',
    master: 'none',
    viewer: 'view',
    employee: 'none',
  },
  {
    module: 'Журнал безопасности',
    admin: 'full',
    ot_specialist: 'view',
    department_head: 'none',
    master: 'none',
    viewer: 'view',
    employee: 'none',
  },
  {
    module: 'Пользователи',
    admin: 'full',
    ot_specialist: 'none',
    department_head: 'none',
    master: 'none',
    viewer: 'none',
    employee: 'none',
  },
  {
    module: 'НПА и документы',
    admin: 'full',
    ot_specialist: 'full',
    department_head: 'view',
    master: 'view',
    viewer: 'view',
    employee: 'view',
  },
  {
    module: 'Отчётность',
    admin: 'full',
    ot_specialist: 'full',
    department_head: 'view',
    master: 'view',
    viewer: 'view',
    employee: 'none',
  },
];

/** GET /api/admin/audit-log — журнал безопасности. Бэкенд: datetime ISO, user (login), action. */
export const auditLog: AuditLogEntry[] = [
  { id: 1, datetime: '28.04.2026 10:42', user: 'p.ivanova', action: 'Вход в систему (учётная запись)' },
  { id: 2, datetime: '28.04.2026 10:45', user: 'p.ivanova', action: 'Изменение записи медосмотра #3241' },
  { id: 3, datetime: '28.04.2026 09:15', user: 'n.karpov', action: 'Вход в систему (учётная запись)' },
  { id: 4, datetime: '27.04.2026 17:30', user: 'v.gromov', action: 'Добавлен пользователь o.zajcev' },
  { id: 5, datetime: '27.04.2026 14:10', user: 'p.ivanova', action: 'Экспорт отчёта PDF «Медосмотры»' },
];
